<template>
    <Button v-if="$temAcessoView('MAPAPARC-PAR-ACAO-EXP-LISTA')" :disabled='!habilita' class='ml-2'
            icon='pi pi-fw pi-file-excel'
            label='Exportar para Excel' @click='obterArquivo()' />
</template>

<script>
import Services from '../../service.js';

export default {
    props: {
        idParceria: {
            type: Number,
        },
        habilita: {
            type: Boolean,
            required: true,
        },
    },

    methods: {
        obterArquivo() {
            this.$store.dispatch('addRequest');
            Services.ExportarAcoesDaParceriaEmExcel(this.idParceria)
                .then((response) => {
                    this.$download(response.data, 'AcoesDaParceria.xlsx');
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                })
        },
    },
};
</script>
